import React, { useState } from "react";
import { PeekGrid, PeekPaper } from "@piiqtechnologies/ui-components";
import { AiDiscoverabilityForm } from "./form";
import { AiDiscoverabilityResultContent } from "./result-content";
export const AiDiscoverabilityPanel = () => {
    const [aiDiscoveryResult, setAiDiscoveryResult] = useState();
    return (React.createElement(PeekGrid, { container: true, spacing: 3, alignItems: "stretch" },
        React.createElement(PeekGrid, { item: true, xs: 12, md: 4 },
            React.createElement(PeekPaper, { sx: { p: 3 } },
                React.createElement(AiDiscoverabilityForm, { onResult: (result) => setAiDiscoveryResult(result) }))),
        React.createElement(PeekGrid, { item: true, xs: 12, md: 8 },
            React.createElement(AiDiscoverabilityResultContent, { results: aiDiscoveryResult }))));
};
export default AiDiscoverabilityPanel;
